import { atom } from 'jotai';

export const updateInviteList = atom(0);
